import React, { useEffect, useState, useCallback } from 'react';
import CountdownTimer from 'react-component-countdown-timer';

const Countdown_Timer = (props) => {
  const [settings, setsettings] = useState({
    count: props.count,
    border: true,
    showTitle: true,
    noPoints: true,
  });

  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);

  useEffect(() => {
    setsettings({
      count: props.count,
      border: true,
      showTitle: true,
      noPoints: true,
    });
    let timer = setTimeout(() => {
      props.endTimer()
    }, props.count * 1000);
    forceUpdate();
    return () => clearTimeout(timer);
  }, [props.count]);

  return (
    <div className="d-flex flex-row">
      <CountdownTimer
        responsive
        {...settings}
        size={50}
        hideDay
        hideHours
        showTitle
        border
        backgroundColor={props.color}
      />
    </div>
  );
};

export default Countdown_Timer;
